/**
 * What ties a dialog field to the error shown under it, so a screen reader
 * announces the field as invalid and reads the message with it. Kept out of
 * the component for the node vitest (see profile-tabs.ts). [HW-1008]
 */

export const fieldErrorId = (fieldId: string) => `${fieldId}-error`;

export function invalidProps(
  fieldId: string,
  error: string | undefined
): { 'aria-invalid'?: true; 'aria-describedby'?: string } {
  return error ? { 'aria-invalid': true, 'aria-describedby': fieldErrorId(fieldId) } : {};
}

/** `errors` without `key`'s message: a field being edited stops showing its old error. [HW-1008] */
export function withoutFieldError<E extends Partial<Record<string, string>>>(
  errors: E,
  key: keyof E
): E {
  if (!errors[key]) return errors;
  const rest = { ...errors };
  delete rest[key];
  return rest;
}

/**
 * The element id of the first field with an error, in the order the form shows
 * them (`fields` pairs each form key with its element id). [HW-1008]
 */
export function firstInvalidFieldId<K extends string>(
  fields: readonly (readonly [K, string])[],
  errors: Partial<Record<K, string>>
): string | undefined {
  return fields.find(([key]) => errors[key])?.[1];
}
